<!--
 * @Author: Merlin
 * @Date: 2023-12-07 18:30:56
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-09 11:27:07
 * @Description: 
-->
<template>
    <TheNav></TheNav>
    <div class="p-8">
        <br />
        <br />
        <!-- <CasinoResultTab v-model="sNowTab" :items="['history', 'myBets', 'highRollers', 'rareWins']"></CasinoResultTab> -->
        <br />
        <br />
        <div class="row">
            <CasinoWidgetRTP type="old"></CasinoWidgetRTP> &emsp;
            <CasinoWidgetRTP type="new"></CasinoWidgetRTP>
        </div>
        <br />
        <br />
        <q-btn color="primary">
            hover 触发显示提示
            <q-tooltip class="triangle" anchor="top middle" self="bottom middle">
                <div>
                    <h5>示例01：</h5>
                    <p>为提示框添加“向下的三角符号”：为组件 ＜q-tooltip＞ 添加 class “triangle”</p>
                </div>
            </q-tooltip>
        </q-btn>
        &emsp;&emsp;
        <q-btn color="primary">
            hover 触发显示提示
            <q-tooltip class="triangle" anchor="top middle" self="bottom middle" max-width="250px">
                <div>
                    <h5>示例02：</h5>
                    <p>♥ 推荐设定 max-width 🌹🌹</p>
                    <p>为提示框添加“向下的三角符号”：为组件 ＜q-tooltip＞ 添加 class “triangle”</p>
                </div>
            </q-tooltip>
        </q-btn>
    </div>
    <div class="p-8">
        <ButtonThe3DButton
            @click="()=> modelValue=true"
        >
            点击弹出窗口
        </ButtonThe3DButton>
        <ModalTitle
            :model-value="modelValue"
            @update:model-value="fnModalValueChanged"
            :backdrop="false"
            container-class="hello"
        >
            <template #header>
                <span class="">
                    This is header 
                </span>
            </template>
            <div class=""
                :style="{
                    color: 'white',
                    border: 'solid 1px #666',
                }"
            >
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
                This is header Modal body<br/>
            </div>
            <template #footer>
                <p class="">
                    This is footer 
                </p>
            </template>
        </ModalTitle>
    </div>
    <div class="p-8">
        <br />
        <h3>👇游戏控制表单中的“手动自动”切换器</h3>
        <div class="row pb-8">
            <div class="w-[250px]">
                <CasinoWidgetSwitchMode v-model="isAutoMode"></CasinoWidgetSwitchMode>
            </div>
            &emsp;
            <div class="w-[350px]">
                <CasinoAutoSection></CasinoAutoSection>
            </div>
        </div>
        <br />
        <h3>👇切换器</h3>
        <div class="row pb-8 ">
            <div class="flex flex-col items-start w-1/4">
                <Toggle label="" v-model="isAutoMode"></Toggle>
                默认
            </div>
            <div class="flex flex-col items-start w-1/4">
                <Toggle label="Auto" v-model="isAutoMode"></Toggle>
                有标题
            </div>
        </div>
        <br />
        <h3>👇以下是游戏中自动模式的提示（点击有弹窗）</h3>
        <div class="row">
            <CasinoWidgetAutoTip />&nbsp;默认尺寸
            &emsp;&emsp;
            <CasinoWidgetAutoTip size="22px" />&nbsp;指定尺寸
            &emsp;&emsp;
            <CasinoWidgetAutoTip size="28px" ref="autoModeTip" />&nbsp;指定尺寸
        </div>
        <br />
        <button class="bg-cyan-500" @click="showTipDialog">
            点击我，触发提示窗口弹出（外部触发）
        </button>
        <br/>
        <div class="row pt-8">👇下拉框组件</div>
        <div class="row pt-2 flex">
            <!-- 选中项带icon展示 -->
            <!-- <div class="flex-1">
                <Select 
                    :options="selectPrevIcon.options" 
                    :model="selectPrevIcon.model" 
                    :disabled="selectPrevIcon.disabled" 
                    :update="(value) => handleSelectUpdate(value, 'prevIcon')"
                >
                    <p v-html="selectPrevIcon.riskSvg" name="prev-icon"></p>
                </Select>
            </div>
            <div class="flex-1">
                <Select 
                    :options="selectOptionIcon.options" 
                    :model="selectOptionIcon.model" 
                    :disabled="selectOptionIcon.disabled" 
                    :update="(value) => handleSelectUpdate(value, 'optionIcon')"
                    label="RISK"
                >
                    <p v-html="prevIcon" name="prev-icon"></p>
                </Select>
            </div>
            <div class="flex-1">
                <Select 
                    :options="selectPrevLabel.options" 
                    :model="selectPrevLabel.model" 
                    :disabled="selectPrevLabel.disabled" 
                    :update="(value) => handleSelectUpdate(value, 'prevLabel')"
                    :prevLabel="selectPrevLabel.prevLabel"
                >
                </Select>
            </div> -->
        </div>
    </div>
</template>

<script>
import TheNav from './nav.vue';

// import Select from '@/components/Casino/Select';

import img1 from '@/assets/imgs/casino/keno/icon-risk-low.webp';
import img2 from '@/assets/imgs/casino/keno/icon-risk-medium.webp';
import img3 from '@/assets/imgs/casino/keno/icon-risk-high.webp';

export default {
    components: {
        TheNav,
        // Select,
    },
    data() {
        return {
            modelValue: false,
            sNowTab: 'myBets',
            isAutoMode: false,
            selectPrevIcon: {
                options: ['Low', 'Medium', 'High'],
                model: 'Medium',
                disabled: false,
                riskSvg: '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#43BBFF"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#6AF6FF"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>'
            },
            selectPrevLabel: {
                options: ['Low', 'Medium', 'High'],
                model: 'Medium',
                disabled: false,
                prevLabel: 'RISK：'
            },
            selectOptionIcon: {
                options: [{
                    label: 'Low',
                    value: 'Low',
                    optionIcon: `<img src=${img1} class="w-6 h-6" />`,
                },
                {
                    label: 'Medium',
                    value: 'Medium',
                    optionIcon: `<img src=${img2} class="w-6 h-6" />`,
                },
                {
                    label: 'High',
                    value: 'High',
                    optionIcon: `<img src=${img3} class="w-6 h-6" />`,
                }],
                model: 'Medium',
                disabled: false,
                riskSvg: '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#43BBFF"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#6AF6FF"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>'
            },
            prevIcon: `<img src=${img2} class="w-6 h-6" />`
        };
    },
    methods: {
        showTipDialog() {
            this.$refs.autoModeTip.bReminderVisible = true;
        },
        handleSelectUpdate(value, type) {
            const val = value && typeof value === 'object' ? value.value : value;
            
            if (type === 'prevIcon'){
                this.selectPrevIcon.model = val;
                switch (val) {
                    case 'High':
                        this.selectPrevIcon.riskSvg = '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#FF9900"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#FFC700"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#FF3D00"></stop></radialGradient></defs></svg>';
                        break;
                    case 'Medium':
                        this.selectPrevIcon.riskSvg = '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#5CCE03"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#F2E407"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#D1FF50"></stop></radialGradient></defs></svg>';
                        break;
                    case 'Low':
                        this.selectPrevIcon.riskSvg = '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#43BBFF"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#6AF6FF"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>';
                        break;
                    default:
                        this.selectPrevIcon.riskSvg = '<svg data-v-1ebc74b7="" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle data-v-1ebc74b7="" cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs data-v-1ebc74b7=""><radialGradient data-v-1ebc74b7="" id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop data-v-1ebc74b7="" stop-color="#43BBFF"></stop><stop data-v-1ebc74b7="" offset="0.697917" stop-color="#6AF6FF"></stop><stop data-v-1ebc74b7="" offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>';

                }
            } else if (type === 'optionIcon') {
                this.selectOptionIcon.model = val;
                this.prevIcon = value.optionIcon;
            } else {
                this.selectPrevLabel.model = val;
            }
            
            // return;
            
        },
        fnModalValueChanged(newVal){
            console.log('fnModalValueChanged:', newVal);
            this.modelValue = newVal;
        },
    },
}
</script>

<style></style>
